import { render } from "./SubscriptionsView.vue?vue&type=template&id=7bcce89a"
import script from "./SubscriptionsView.vue?vue&type=script&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__